<div class="forgot-password-page">
    <div class="forgot-password-container">
        <div class="forgot-password-card">
            <!-- Logo Section -->
            <div class="logo-header">
                <img src="assets/images/lens-blueprint-logo.svg" alt="Lens Blueprint" class="brand-logo"
                    onerror="this.style.display='none'" />
                <h1 class="brand-title">Lens Blueprint</h1>
                <p class="brand-subtitle">Assessment Dashboard</p>
            </div>

            <!-- Form Section -->
            <div class="form-section" *ngIf="!showSuccessMessage">
                <h2 class="form-title">Forgot Password?</h2>
                <p class="form-description">Enter your email address and we'll send you a link to reset your password.</p>

                <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="forgot-password-form">
                    <!-- Error Message -->
                    <div class="error-alert" *ngIf="error">
                        <mat-icon>error_outline</mat-icon>
                        <span>{{ error }}</span>
                    </div>

                    <!-- Email Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="email" type="email" placeholder="Enter your email" />
                        <mat-icon matSuffix>email</mat-icon>
                        <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('email')">
                            Please enter a valid email address
                        </mat-error>
                    </mat-form-field>

                    <!-- Submit Button -->
                    <button mat-raised-button type="submit" [disabled]="!forgotPasswordForm.valid || loading" class="submit-btn">
                        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
                        <mat-icon *ngIf="!loading">send</mat-icon>
                        <span *ngIf="!loading">Send Reset Link</span>
                    </button>

                    <!-- Back to Login Link -->
                    <div class="back-to-login">
                        <a routerLink="/login" class="back-link">
                            <mat-icon>arrow_back</mat-icon>
                            <span>Back to Sign In</span>
                        </a>
                    </div>
                </form>
            </div>

            <!-- Success Message Section -->
            <div class="success-section" *ngIf="showSuccessMessage">
                <div class="success-icon">
                    <mat-icon>check_circle</mat-icon>
                </div>
                <h2 class="form-title">Check Your Email</h2>
                <p class="form-description">
                    We've sent a password reset link to <strong>{{ submittedEmail }}</strong>.
                    Please check your email and click the link to reset your password.
                </p>
                <p class="form-description" style="font-size: 14px; margin-top: 10px;">
                    Didn't receive the email? Check your spam folder or try again.
                </p>
                <button mat-raised-button class="submit-btn" (click)="goToLogin()">
                    <mat-icon>login</mat-icon>
                    <span>Back to Sign In</span>
                </button>
            </div>

            <!-- Footer -->
            <div class="forgot-password-footer">
                <p class="footer-text">
                    Remember your password?
                    <a routerLink="/login" class="footer-link">Sign in here</a>
                </p>
                <p class="copyright">&copy; {{ currentYear }} Lens Blueprint. All rights reserved.</p>
            </div>
        </div>
    </div>
</div>
